import React, { useCallback, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { formatDate, setTranslationValues } from '../../../../helpers';
import { useStore, useTranslation } from '../../../../hooks';
import { PromoModal } from './promo-modal';
import { T } from '../../../../constants';

import './style.scss';

interface PromoProps {

}

export const Promo: React.FC<PromoProps> = observer(() => {

  const { promoStore, gameStore } = useStore();
  const { gameId, currencySymbol } = gameStore;
  const { claimPromoResponse, promoModalOpen } = promoStore;
  const {
    isLoading: claimLoading,
    data: {
      result: claimResult,
      errorMessage: claimErrorMessage
    }
  } = claimPromoResponse;
  
  const t = useTranslation();
  const [ promoCode, setPromoCode ] = useState('');

  const togglePromoModal = useCallback(() => {
    promoStore.setPromoModalOpen(!promoModalOpen);
  }, [promoModalOpen]);

  const handlePromoCodeChange = useCallback((value: string) => {
    setPromoCode(value);
  }, [setPromoCode]);

  const handleClaimClick = useCallback(() => {
    promoStore.claimPromo({ code: promoCode.trim(), gameId });
  }, [promoCode, gameId]);

  const claimSucceeded = useMemo(() => {
    return !!claimResult && !claimErrorMessage;
  }, [claimResult, claimErrorMessage]);

  const errorMessage = useMemo(() => {
    if (!claimErrorMessage) return '';
    if (claimResult && typeof claimResult === 'object') {
      const trValues = {
        currentWagerAmount: `${claimResult.currentTurnoverAmount}${currencySymbol}`,
        wagerGoalAmount: `${claimResult.turnoverGoalAmount}${currencySymbol}`,
        wagerStartDate: formatDate(new Date(claimResult.turnoverStartDate)),
        wagerEndDate: formatDate(new Date(claimResult.turnoverEndDate)),
      };
      return setTranslationValues(t(claimErrorMessage), trValues);
    }
    return t(claimErrorMessage);
  }, [claimErrorMessage, claimResult, currencySymbol, t]);

  const claimSuccessMessage = useMemo(() => {
    if (!claimSucceeded) return '';
    return setTranslationValues(t(T.PROMO_SUCCESS_MESSAGE), { value: claimResult as number || 10 });
  }, [claimSucceeded, claimResult, t]);

  return (
    <>
      {
        promoModalOpen && (
          <PromoModal
            promoCode={promoCode}
            onClose={togglePromoModal}
            claimLoading={claimLoading}
            claimSucceeded={claimSucceeded}
            onClaimClick={handleClaimClick}
            claimErrorMessage={errorMessage}
            claimSuccessMessage={claimSuccessMessage}
            onPromoCodeChange={handlePromoCodeChange}
          />
        )
      }
    </>
  );
});
